import { defineAnalytics } from '@zg-rentals/rentals-analytics';
import { tracker as CLICKSTREAM } from '@zg-rentals/clickstream';
import type { ContactRequestForm, PropertyInfo } from './types';

export const analytics = defineAnalytics({ CLICKSTREAM });

export const trackCsEvent = analytics.createTrackEvent('CLICKSTREAM');

export const trackPropertyInfoCsEvent = analytics.createTrackEvent<'CLICKSTREAM', PropertyInfo>('CLICKSTREAM');

export const trackContactRequestFormCsEvent = analytics.createTrackEvent<
  'CLICKSTREAM',
  PropertyInfo & ContactRequestForm
>('CLICKSTREAM');
